import { Public } from '../types';
import { IErrorMessageService } from './error-message-service';
import { IHttpService } from './http-service';
import {
  Environment,
  EnvironmentKey,
  EnvironmentValue
} from './types';

export type IEnvironmentService = Public<EnvironmentService>;

type ServerEnvironment = Record<EnvironmentKey, EnvironmentValue>;

/** Service that pulls environment variables that start with `REACT_` from the backend. */
export class EnvironmentService {
  public static readonly baseUrl = '/environment';
  public readonly environment: Promise<Environment>;
  private _errorMessageService: IErrorMessageService;
  private _httpService: IHttpService;

  constructor(
    errorMessageService: IErrorMessageService,
    httpService: IHttpService
  ) {
    this._errorMessageService = errorMessageService;
    this._httpService = httpService;
    this.environment = this._getEnvironment();
  }

  /** Get environment variables from the server. */
  private async _getEnvironment(): Promise<Environment> {
    const {
      error,
      value
    } = await this._httpService.fetchJson<ServerEnvironment>({
      url: ''
    });

    if (error) {
      this._errorMessageService.addError(error);
      throw error;
    }

    const {
      [EnvironmentKey.authTokenRefreshCountLimit]: authTokenRefreshCountLimit
    } = value;

    return {
      authTokenRefreshCountLimit: this.parseNumber(authTokenRefreshCountLimit)
    };
  }

  private parseNumber(value: EnvironmentValue): number {
    const parsedValue = (typeof value === 'number') ? value : (
      parseInt(value ?? '0', 10)
    );

    return (isNaN(parsedValue)) ? 0 : parsedValue;
  }
}
